import { Warning } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { Container } from '@mui/system';
import { AppState } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import { useSession } from '../libraries/SessionProvider';
import { useWindowDimensions } from '../libraries/useWindowDimensions';
import { CenteredSearch } from './CenteredSearch';
import DrawerMenu from './DrawerMenu';
import { LeftTopMenu } from './LeftTopMenu';

const MainHeader = () => <Container
    maxWidth={false}
    sx={{
        alignItems: 'center',
        columnGap: { xs: 0.5, sm: 2 },
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        minHeight: { xs: 56, sm: 60 },
        px: { xs: 1, sm: 3 }
    }}
>
    <DrawerMenu />
    <CenteredSearch />
    <LeftTopMenu />
</Container>;

export const MasterViewPage = (props: { children?: React.ReactNode | React.ReactNode[]; }) => {

    const windowDimensions = useWindowDimensions();



    const hideMasterPage = useMatch('/labeler/print/*') || useMatch('/scanmode/*');
    const { user } = useSession();



    const getContent = () => {
        if (!user || hideMasterPage) {
            return <>{props.children}</>;
        } else {
            return <div style={{ minHeight: windowDimensions.height }}>
                <MainHeader />
                <Container maxWidth={false}>{props.children}</Container>
            </div>;
        }
    };
    return <>{getContent()}</>;

};


export const OLDMPV = (props: { children?: React.ReactNode | React.ReactNode[]; }) => {

    const windowDimensions = useWindowDimensions();

    const googleDriveConnected = useSelector((state: AppState) => state.document.googleDriveConnected);

    const hideMasterPage = useMatch('/labeler/print/*') || useMatch('/scanmode/*');
    const { user, isSuperAdmin } = useSession();

    const onSystemConnectClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        event.stopPropagation();
        document.location.href = '/auth/system';
    };

    const getContent = () => {
        if (!user || hideMasterPage) {
            return <>{props.children}</>;
        } else {
            return <div style={{ minHeight: windowDimensions.height }}>
                {isSuperAdmin && googleDriveConnected === false && <Container><Alert icon={<Warning />} severity='warning'>Le serveur a été déconnecté de google drive. Un admin doit <a href="#" onClick={onSystemConnectClick}>effectuer la connexion</a>.</Alert></Container>}
                <MainHeader />
                <Container maxWidth={false}>{props.children}</Container>
            </div>;
        }
    };
    return <>{getContent()}</>;

};
